export default __webpack_public_path__ + "static/media/frangot-screenshot-06.c54a1e61.png";